module.exports = __webpack_public_path__ + "assets/img/24_430.b695328d.jpg";